import { render, staticRenderFns } from "./RcnSingleTemplate.vue?vue&type=template&id=0787f71f&"
import script from "./RcnSingleTemplate.vue?vue&type=script&lang=js&"
export * from "./RcnSingleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports